import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import { produce } from 'immer';
import Button from '../../../../../../common/widgets/Button';
import Icons from '../../../../../../common/widgets/Icons';
import { resources } from '../../../../resources/resources';
import GenerateReportDialog from '../Dialogs/GenerateReportDialog';
import { FinalReportState } from '../FinalReportState';

interface IGenerateReportProps {
  state: FinalReportState;
  setState: Dispatch<SetStateAction<FinalReportState>>;
}
export default function GenerateReport(props: IGenerateReportProps) {
  const { state, setState } = props;

  const { t: translate } = useTranslation();

  return (
    <div className="inline-form">
      <Button
        className="btn btn-solid btn-sm"
        loading={state.isGeneratingReport}
        onClick={() => {
          setState(
            produce(d => {
              d.showGenerateReportDialog = true;
            }),
          );
        }}
        icon={<Icons.Report />}
      >
        <span className="btn-text">
          {translate(resources.admin.finalReport.generate.action)}
        </span>
      </Button>
      {state.showGenerateReportDialog && (
        <GenerateReportDialog
          onCloseGenerateDialog={() => {
            setState(
              produce(d => {
                d.showGenerateReportDialog = false;
              }),
            );
          }}
          state={state}
          setState={setState}
        />
      )}
    </div>
  );
}
